import { useTranslation } from 'react-i18next'
import { RecommendationCard, Skeleton } from '@/ds'
import { formatMoney } from '@/lib/format'
import { useAppNavigate } from '@/lib/query-params'
import { extrasService } from '@/services/extras'
import type { Stay } from '@/services/reserva'
import type { StayData } from '../useStayData'

/** Una recomendación por fase (DESIGN.md §4). Sin dato, no se muestra nada: nunca se inventa. */
export function RecoSection({ stay, data, lang }: { stay: Stay; data: StayData; lang: string }) {
  const { t } = useTranslation()
  const { go } = useAppNavigate()
  const reco = data.recommendation
  if (reco.kind === 'loading') return <Skeleton height={140} radius={16} />
  if (reco.kind !== 'ready' || !reco.value) return null
  const r = reco.value
  const price = r.price ? (r.priceUnit && r.priceUnit !== 'total' ? t(`v2.estancia.precioUnidad.${r.priceUnit}`, { price: formatMoney(r.price, lang) }) : formatMoney(r.price, lang)) : undefined
  return (
    <RecommendationCard
      reason={r.reason}
      title={r.title}
      {...(price ? { price } : {})}
      actionLabel={r.actionLabel}
      onAction={() => go('/reserva/extras', { state: { extraId: r.extraId } })}
      onDismiss={() => void extrasService.dismissRecommendation(stay, r.id)}
    >
      {r.text}
    </RecommendationCard>
  )
}
